import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Auth, UsuarioConectado } from '../../model/auth.model';
import { TokenStorageService } from '../storage/token-storage.service';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class AuthStoreService {
  private loggedInSubject: BehaviorSubject<boolean>;
  private esEmbebido: BehaviorSubject<boolean>;
  private contenedor: BehaviorSubject<string>;
  private usuarioConectadoSubject = new BehaviorSubject<UsuarioConectado>(this.tokenStorage.getUserInfo());

  private readonly THEME_LINK_ID = 'theme-stylesheet';

  private readonly THEMES = {
    base: '/assets/themes/base-theme.min.css',
    umbrela: '/assets/themes/umbrela.min.css',
    mediacion: '/assets/themes/mediacion-liferay.min.css',
    helvetia: '/assets/themes/helvetia.min.css'
  };

  constructor(
    private tokenStorage: TokenStorageService,
    private router: Router,  
		@Inject(DOCUMENT) private readonly documentRef: Document
  ) {
    this.esEmbebido = new BehaviorSubject<boolean>(this.tokenStorage.esEmbebido());
    this.contenedor = new BehaviorSubject<string>(null);
    this.loggedInSubject = new BehaviorSubject<boolean>(this.tokenStorage.getAccessToken() !== null);
  }

  public clearStorage(contenedor: string | null){
    this.loggedInSubject.next(false);
    this.usuarioConectadoSubject.next(null);
    this.tokenStorage.clearSession();
    if (contenedor) {
      this.contenedor.next(contenedor);
    }
    this.esEmbebido.next(false);
    this.updateUsuarioConectado();
  }

  logout(): void {
    this.tokenStorage.clearSession();
    this.loggedInSubject.next(false);
    this.usuarioConectadoSubject.next(null);
    this.cargarTema(this.THEMES.base);
    this.router.navigate(['/login']);
  }

  isLoggedIn(): boolean {
    return this.loggedInSubject.value;
  }

  getLoggedInStatus(): Observable<boolean> {
    return this.loggedInSubject.asObservable();
  }

  public handleAuthSuccess(auth: Auth, suplantado:boolean): void {
    this.clearStorage(auth.contenedor);
    this.tokenStorage.setAccessToken(auth.access_token);
    this.tokenStorage.setRefreshToken(auth.refresh_token);
    if (suplantado){
      this.tokenStorage.setUserSuplantadoInfo(auth.user_info);
    } else {
      this.clearSuplantado();
      this.tokenStorage.setUserInfo(auth.user_info);
    }
    this.loggedInSubject.next(true);
    this.updateUsuarioConectado();
  }

  public getEsEmbebido(): boolean {
    return (this.tokenStorage.esEmbebido());
  }

  public getContenedorObservable(): Observable<string> {
    return this.contenedor.asObservable();
  }

  public getRefreshToken(): string{
    return this.tokenStorage.getRefreshToken();
  }

  public getAccessToken(): string{
    return this.tokenStorage.getAccessToken();
  }

  public clearSuplantado(): void {
    this.tokenStorage.clearSuplantado();
    this.updateUsuarioConectado();
  }

  public refreshTokens(auth: Auth){
    this.tokenStorage.setAccessToken(auth.access_token);
    this.tokenStorage.setRefreshToken(auth.refresh_token);
    this.loggedInSubject.next(true);
    this.updateUsuarioConectado();
  }

  public getUsuarioActivo() {
    return this.tokenStorage.getActiveUser();
  }

  public getUsuarioConectado(): Observable<UsuarioConectado> {
    return this.usuarioConectadoSubject.asObservable();
  }
  
  public updateUsuarioConectado() {
    this.usuarioConectadoSubject.next(this.tokenStorage.getUserInfo());
  }

  public getTema() {
    return this.usuarioConectadoSubject.value?.tema;
  }

  public cargarTema(theme: string): void {
		let themePath = this.THEMES[theme as keyof typeof this.THEMES];
		if (!themePath) {
      themePath = this.THEMES.base;
      theme = 'base';
		}
		let themeLink = this.documentRef.getElementById(this.THEME_LINK_ID) as HTMLLinkElement;
		themeLink.href = themePath;
	
    if (this.usuarioConectadoSubject.value) {
      this.usuarioConectadoSubject.value.tema = theme;
    }    
    this.tokenStorage.setTema(theme);
	}

}

